import { StrategyBuilderFunction, EMPTY_STRATEGY } from './types';
import { addLongPut, addShortPut } from './addOption';
import {
  getDefaultExpiration,
  findClosestStrikePrice,
  getStrikesAtExpiration,
  expirationToDate,
  getPremium,
  getStrategyLegStrikeDirection,
  getStrikeDistance,
} from './utils';

export const shortPutButterfly: StrategyBuilderFunction = ({
  chain,
  spot,
  expirationDate,
  expirationKey,
  strikeDirection,
  contractMultiplier = 1,
}) => {
  const strikesAtExpiration = expirationKey
    ? getStrikesAtExpiration(chain, expirationKey)
    : getDefaultExpiration(chain);

  if (
    !strikesAtExpiration ||
    !strikesAtExpiration.e ||
    !strikesAtExpiration.ey ||
    !strikesAtExpiration.em ||
    !strikesAtExpiration.ed
  ) {
    return EMPTY_STRATEGY;
  }

  const expirationDateForOptions =
    expirationDate ||
    expirationToDate(strikesAtExpiration.ey, strikesAtExpiration.em, strikesAtExpiration.ed);
  const expirationKeyForOptions = expirationKey || strikesAtExpiration.e;

  // Define strike prices
  const itmPutStrike = findClosestStrikePrice(
    strikesAtExpiration,
    getStrikeDistance({ price: spot, unit: -2 }),
  ); // Selling ITM put
  const atmPutStrike = findClosestStrikePrice(strikesAtExpiration, spot); // Buying ATM puts
  const otmPutStrike = findClosestStrikePrice(
    strikesAtExpiration,
    getStrikeDistance({ price: spot, unit: 2 }),
  ); // Selling OTM put

  return {
    optionPositions: [
      // Sell 1 ITM put option
      addShortPut({
        strike: itmPutStrike,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[itmPutStrike]?.p?.a || 0,
          bid: strikesAtExpiration?.c?.[itmPutStrike]?.p?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'short'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 1 * contractMultiplier,
      }),
      // Buy 2 ATM put options
      addLongPut({
        strike: atmPutStrike,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[atmPutStrike]?.p?.a || 0,
          bid: strikesAtExpiration?.c?.[atmPutStrike]?.p?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'long'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 2 * contractMultiplier,
      }),
      // Sell 1 OTM put option
      addShortPut({
        strike: otmPutStrike,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[otmPutStrike]?.p?.a || 0,
          bid: strikesAtExpiration?.c?.[otmPutStrike]?.p?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'short'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 1 * contractMultiplier,
      }),
    ],
    stockPositions: [],
  };
};
